/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon20Solid = forwardRef('WeatherThermometerIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5a4 4 0 1 1 8 0v4.725a5.5 5.5 0 1 1-8 0V5Zm4 .75a1 1 0 0 1 1 1v4.458a2.5 2.5 0 1 1-2 0V6.75a1 1 0 0 1 1-1Z" })));
});
